export function formatOtpExpiryHint(expiryEpochSeconds) {
  if (!expiryEpochSeconds) return null;
  const expiryMs = Number(expiryEpochSeconds) * 1000;
  if (!Number.isFinite(expiryMs)) return null;
  const remaining = Math.max(0, Math.ceil((expiryMs - Date.now()) / 1000));
  if (remaining <= 0) return "This code has expired. Request a new one.";
  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;
  if (minutes > 0) return `Code expires in ${minutes}m ${seconds}s.`;
  return `Code expires in ${seconds}s.`;
}

export function formatOtpError(message = "") {
  const lower = String(message).toLowerCase();
  if (lower.includes("session") && lower.includes("expir")) {
    return "This verification code has expired. Request a new code to continue.";
  }
  if (lower.includes("expir")) {
    return "This verification code has expired. Request a new code to continue.";
  }
  if (lower.includes("authentication failed") || lower.includes("incorrect")) {
    return "Incorrect code. Check the digits and try again, or request a new code before it expires.";
  }
  if (lower.includes("too many")) {
    return "Too many incorrect attempts. Request a new verification code.";
  }
  return message || "Incorrect code. Request a new verification code if needed.";
}
